



import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * API
 */
import settingsAPI from '@/api/settings';

/**
 * Components
 */
import SettingsEditor from './components/Editor.vue';

/**
 * Types
 */
import { SettingsCategories } from '@/api/settings';

/**
 * Page des configurations de personnalisation.
 */
@Component({ components: { SettingsEditor } })
export default class CustomizationSettingsPage extends Vue {
	/** Attributs */

	/** Méthodes */
	async fetchSettings() {
		return await settingsAPI.getAllSettings(SettingsCategories.CUSTOMIZATION);
	}

	async saveSettings(formData: FormData) {
		return await settingsAPI.saveAllSettings(formData);
	}
}
